import { useTranslation } from 'next-i18next';
import { MdInfoOutline } from 'react-icons/md';
import { useCustomTranslations } from '../../../../../hooks/useCustomTranslations';
import { RegistrationField, TextValueOption } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import { ConditionalWrapper } from '../../../../common/ConditionalWrapper';
import VyTooltip from '../../../../common/VyTooltip';

interface CardOptionProps {
  onChange: (value: any) => void;
  field: RegistrationField;
  value: any;
  tvo: TextValueOption;
  onShowAdditionalInfos: (tvo: TextValueOption) => void;
  disabled?: boolean;
  fieldsTextColor?: string;
  fieldsBorderColor?: string;
}
export const CardOption = ({ onChange, field, value, tvo, onShowAdditionalInfos, disabled, fieldsTextColor, fieldsBorderColor }: CardOptionProps) => {
  const { t } = useTranslation();
  const { ct } = useCustomTranslations();

  const event = useSelector((state) => state.common.event);

  ct(field.label, field, 'labelTranslations');

  const isSelected =
    value === tvo.content ||
    value.split(',').find((v: string) => {
      return v === `${tvo.content}`;
    });

  const opacity = disabled ? 'opacity-25' : !isSelected || disabled ? 'opacity-50' : 'opacity-100';

  return (
    <ConditionalWrapper
      condition={disabled === true}
      wrapper={(children) => <VyTooltip title={tvo.limitWarning || t('common:tooltip-signup-limited')}>{children}</VyTooltip>}>
      <div
        onClick={() => {
          if (disabled) return;
          if (field.canMultiSelect) {
            /**
             * TODO: Registration currently includes commas
             * This will be fixed when VY-6813 is merged soon
             */
            if (isSelected) {
              return onChange(value.replaceAll(`,${tvo.content},`, ''));
            }
            return onChange(`${value} ,${tvo.content}, `);
          }
          !isSelected ? onChange(tvo.content) : onChange('');
        }}
        className={`w-full ${opacity} rounded-sm flex flex-col overflow-hidden ${!disabled ? 'cursor-pointer' : ''}`}>
        {tvo.cardImage && <img style={{ width: '100%', height: '80%', objectFit: 'contain' }} src={createDisplayLink(tvo.cardImage)} />}
        <div
          className={`p-2 flex flex-row justify-between align-center ${isSelected ? '' : 'bg-slate-200'}`}
          style={{
            ...(tvo.cardImage ? { minHeight: '64px' } : {}),
            ...(isSelected && !tvo.cardImage
              ? { backgroundColor: fieldsBorderColor || event?.template?.mainColor, color: fieldsTextColor || event?.template?.mainButtonTextColor }
              : {}),
          }}>
          <div className="font-bold">{ct(tvo.content, tvo, 'translations')}</div>
          {tvo.additionalInformation && (
            <div
              className="ml-1"
              onClick={(e) => {
                onShowAdditionalInfos(tvo);
                e.stopPropagation();
              }}>
              <MdInfoOutline size="15" />
            </div>
          )}
        </div>
      </div>
    </ConditionalWrapper>
  );
};
